/**
 * This file is a component for E2 UI Customization (This is subject to change based off of mediaType)
 */

 import React, {useState, useEffect} from 'react';
 import { Grid, Tooltip, FormControlLabel, Checkbox} from '@material-ui/core';
 import TextsmsOutlinedIcon from '@material-ui/icons/TextsmsOutlined';
 
 export default function Click2Text(props)
 {
     const [click2Text, setClick2Text] = useState(false);
 
     /** Set callback to value that is being passed through props */
     useEffect(() => {
        setClick2Text(props.value);
     },[props.value]);
 
     /**Handle Changes of callback checkbox */
     const handleClick2Text = () => {
         setClick2Text(!click2Text);
         props.onChange(!click2Text);
     }
 
     return(
         <div>
             <Grid container direction="row" alignItems="center">
                 <Grid item>
                     <FormControlLabel
                     control={
                         <Checkbox
                         checked={click2Text}
                         onChange={handleClick2Text}
                         name="click2text"
                         color="primary"
                         />
                     }
                     label="Click2Text"
                     />
                 </Grid>
                 <Grid item>
                     <Tooltip title="Give permission for Click2Text">
                         <TextsmsOutlinedIcon color="primary"/>
                     </Tooltip>
                 </Grid>
             </Grid>
         </div>
     );
 }
 
 